import { useEffect, useMemo } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { ProjetosFormInicialVerificaKit } from "src/components/projetos/FormInicialVerificaKit";
import { DEFAULT_PROJETO } from "src/components/projetos/constants";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { useObservable } from "src/framework/store/storeUtil";
import { formState$ } from "src/store/vendas/projetos/store";
import { useQuery } from "src/framework/commons/useQuery";
import { ProjetosFormInicialOffGrid } from "src/components/projetos/offgrid/FormInicialOffGrid";
import { appStore } from "src/framework/store/AppStore";
import { notifierStore } from "src/framework/store/NotifierStore";
import { LoginStore } from "src/framework/store/LoginStore";
import { standAlonePage$ } from "src/framework/store/ApiEvents";
import { ProjetosFormInicialHibrido } from "src/components/projetos/hibrido/FormInicialHibrido";
import { ProjetosFormInicialPersonalizadoOffGrid } from "src/components/projetos/personalizados_offgrid/containers/Formulario/FormInicial";
import { ProjetosFormInicialPersonalizadoHibrido } from "src/components/projetos/personalizados_hibrido/containers/Formulario";

const PAGE_TITLE = "Novo projeto";

const FormInicial = ({ tipoProjeto }: { tipoProjeto: string }) => {
  const permissoes = LoginStore.getPermission();

  const permissaoObrigatoria = useMemo(()=>{
    const objPermissoes: {[index: string]: string} = {
      dimensionado_hibrido: PermissionUtil.PERMISSION_PROJETO_DIMENSIONADO_HIBRIDO,
    }

    return objPermissoes[tipoProjeto] || ''
  },[tipoProjeto])

  if ((permissoes || []).length && !!permissaoObrigatoria && !PermissionUtil.can(permissaoObrigatoria, permissoes)) {
    return <Redirect to={{ pathname: '/' }} />
  }

  const forms: {[index: string]: any} = {
    dimensionado_offgrid: <ProjetosFormInicialOffGrid />,
    dimensionado_hibrido: <ProjetosFormInicialHibrido />,
    personalizado_offgrid: <ProjetosFormInicialPersonalizadoOffGrid />,
    personalizado_hibrido: <ProjetosFormInicialPersonalizadoHibrido />
  }

  return forms[tipoProjeto] || <ProjetosFormInicialVerificaKit />
}

const ProjetosFormInicialPage = () => {
  const standAlone = useObservable(standAlonePage$);
  const history = useHistory();
  const query = useQuery();

  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }

  }, []);

  useEffect(() => {
    const permissoes = LoginStore.getPermission();
    if (standAlone) {
      if (!PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_VERTICAIS_MANUTENCAO, permissoes)) {
        history.push('/404', {done: true});
        return;
      } 
      DEFAULT_PROJETO.segmento = 'vertical_ongrid'
      DEFAULT_PROJETO.tipo = 'vertical'
      formState$.next(DEFAULT_PROJETO)
    } else if (standAlone !== undefined && !PermissionUtil.can(PermissionUtil.PROJETOS_MANUTENCAO, permissoes)){
      notifierStore.setNotifier({
        title: "Aviso!",
        content: "Usuário sem permissão!",
        timeOut: 0,
        onClose: () => {
          history.push('/');
          notifierStore.setOpen(false);
          return;
        }
      })
      notifierStore.setOpen(true);
    }
  }, [history, standAlone])

  const tipoProjeto = useMemo(()=>{
    return query.get("tipo") || "dimensionado"
  },[query])

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <FormInicial tipoProjeto={tipoProjeto} />
        </div>
      </div>
    </div>
  );
};

export { ProjetosFormInicialPage };
